import * as themeConstants from '../../Constants/Theme/Theme.constants';
import LoadingImage from 'Assets/TruckMap/icon-plant.png';
import SiteImage from 'Assets/TruckMap/icon-jobsite.png';

const TrucksMapStyles = (theme) => ({
  dialogWrapper: {
    zIndex: 1000000,
  },
  mainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    marginTop: '64px',
    position: 'relative',
  },
  map: {
    height: '100%',
  },
  chipTruck: {
    backgroundColor: '#fff',
    borderColor: '#000',
  },
  truckMarkerIcon: {
    backgroundColor: themeConstants.BORAL_YELLOW,
    border: `2px solid #fff`,
    paddingTop: 3,
    paddingLeft: 1,
  },
  truckMarkerIconWrapper: {
    borderRadius: 1000,
    width: 53,
    height: 54,
    border: '7px solid transparent',
    '&:hover': {
      border: '7px solid #fede008f',
    },
    cursor: `pointer`,
  },
  plantMarkerIconWrapper: {
    height: 48,
    width: 48,
    backgroundImage: `url("${LoadingImage}")`,
    backgroundRepeat: `no-repeat`,
    backgroundSize: `contain`,
    backgroundPosition: `center`,
    cursor: `pointer`,
    '&:hover': {
      backgroundImage: `url("${LoadingImage}")`,
    },
  },
  siteMarkerIconWrapper: {
    height: 48,
    width: 48,
    backgroundImage: `url("${SiteImage}")`,
    backgroundRepeat: `no-repeat`,
    backgroundSize: `contain`,
    backgroundPosition: `center`,
    cursor: `pointer`,
    '&:hover': {
      backgroundImage: `url("${SiteImage}")`,
    },
  },
  truckLoadingMarkerIcon: {
    backgroundColor: '#000',
  },
  truckLoadingMarkerIconWrapper: {
    borderRadius: 1000,
    width: 54,
    height: 54,
    border: '7px solid transparent',
    '&:hover': {
      border: '7px solid #0000004f',
    },
  },
  timeLapseIcon: {
    marginLeft: 8,
    fontSize: 18,
    color: theme.palette.grey[`900`],
  },
  greyDetails: {
    color: theme.palette.grey[`500`],
    fontWeight: 500,
  },
  inTransit: {
    backgroundColor: themeConstants.BORAL_YELLOW,
  },
  arrived: {
    backgroundColor: `#fff`,
    color: '#000',
    position: 'absolute',
    right: 0,
    top: 0,
    fontSize: 10,
    textAlign: `center`,
    borderRadius: 1000,
    minWidth: theme.spacing(1) * 2,
    height: theme.spacing(1) * 2,
    padding: 3,
  },
  infoBox: {
    boxShadow: '0 0 3px #333',
  },
  itemBorder: {
    height: '100%',
    width: 1,
    backgroundColor: '#ccc',
  },
  locationLastUpdated: {
    position: `relative`,
    top: -theme.spacing(1) / 2,
    marginBottom: theme.spacing(1) * 2,
  },
  dotInTransit: {
    '&::before': {
      content: `''`,
      backgroundColor: themeConstants.BORAL_YELLOW,
      width: 16,
      height: 16,
      borderRadius: 1000,
      display: `inline-block`,
      marginRight: theme.spacing(1) / 2,
      marginLeft: theme.spacing(1) / 2,
      verticalAlign: `sub`,
    },
  },
  dotLoading: {
    '&::before': {
      content: `''`,
      backgroundColor: themeConstants.BORAL_GREY,
      width: 16,
      height: 16,
      borderRadius: 1000,
      display: `inline-block`,
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1) / 2,
      verticalAlign: `sub`,
    },
  },
  mapOverlay: {
    position: 'absolute',
    opacity: 0.7,
    backgroundColor: '#f00',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  },
  // plant info sizing
  truckList: {
    maxHeight: 200,
  },
  plantAddress: {
    marginTop: -4,
  },
  truckNoCol: {
    width: 80,
  },
  trucksArrivedCol: {
    width: 100,
  },
  thisLoadCol: {
    width: 70,
  },
  siteProgressiveLoadCol: {
    width: 120,
  },
  progressiveLoadCol: {
    width: 120,
    [theme.breakpoints.down(`sm`)]: {
      width: 100,
    },
  },
  statusCol: {
    width: 70,
  },
  truckRow: {
    lineHeight: 0.9,
    display: `inline-block`,
  },
  loadingCell: {
    width: 150,
  },
});

export default TrucksMapStyles;
